export const StatStrip = ({ items }) => (
  <section className="bg-white border-b border-navy/10 py-8 px-6" data-testid="trust-strip">
    <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-4">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-3 justify-center sm:justify-start">
          <span className="text-accent flex-shrink-0">{item.icon}</span>
          <span className="text-xs sm:text-sm font-medium text-navy/80 tracking-wide">{item.label}</span>
        </div>
      ))}
    </div>
  </section>
);
